<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow; let i = index">

					<td class="text-nowrap" [attr.data-order]="tt.formatDateTimeUTC(item.login_on)">
						{{ item.login_on | date: ac.tableDateTimeFmt }}
					</td>
					<td [hidden]="!fieldsToShow.includes('success')" class="cp-chopped-col-medium">{{ item.success }}</td>

					<td [hidden]="!fieldsToShow.includes('__username') || !showUserInfo" class="text-nowrap"
						[title]="tt.escapeForTitle(item['__username'])">
						<a *ngIf="linkUser && item.user_id > 0" [routerLink]=" ['/' + ac.urls.users, item.user_id]"
							[ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</a>
						<a *ngIf="linkUser && item.user_id < 0" [routerLink]=" ['/' + ac.urls.users, item.user_id * -1]"
							[ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</a>
						<span *ngIf="!linkUser || item.user_id === 0" [ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('__flag')" class="p-0 text-center">
						<img *ngIf="item['__flag']" [src]="item['__flag']" class="cp-list-flag" loading="lazy" />
					</td>
					<td [hidden]="!fieldsToShow.includes('location')">
						{{ item.location }}
					</td>
					<td [hidden]="!fieldsToShow.includes('ip')" class="text-nowrap">{{ item.ip }}</td>

					<td [hidden]="!fieldsToShow.includes('__browser')" class="text-nowrap">
						<fa-icon *ngIf="item.user_id <= 0" [icon]="['fas', 'exclamation-triangle']" size="sm" placement="end"
							class="text-danger" ngbTooltip="Failed Login"></fa-icon>
						{{ item['__browser'] }}
					</td>
					<td [hidden]="!fieldsToShow.includes('tz_id')" class="text-nowrap">
						{{ item.tz_id }}
					</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>